import React, { useEffect, useState } from 'react';
import { Box, colors, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { MESH } from '../../constants';
import { isValidCharWithoutSpace } from '../../lib/site-helper';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { pushAppRoute } from '../../data/domain/route-manager';
import CircularProgress from '@mui/material/CircularProgress';
import deviceStyles from '../../app/device-management/DeviceStyle';
import { ConfirmationPopUp } from '../ConfirmationPopUp/ConfirmationPopUp';
import { MeshDeviceRegistration } from '../../types/device';
import { NavigationPromptModal } from '../NavigationPromptModal/NavigationPromptModal';
import { useDispatch, useSelector } from 'react-redux';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { useAuthHelper } from '../AuthContextProvider';
import { Thunks } from '../../actions';
import { MeshDeviceSelectors } from '../../selectors/mesh-device-selectors';
import { MeshDeviceActions } from '../../actions/actions/mesh-device-actions';
import ReportIcon from '@mui/icons-material/Report';
import { getDaylightsavingDates } from '../../lib/DaylightSavingDates';
import moment from 'moment';
import { SiteSelectors } from '../../selectors/site-selectors';
import { EmptyState } from '@brightlayer-ui/react-components';
export const AddMeshDevice: React.FC<{
    onCancel: Function;
    siteId: string;
    organizationName: string;
    deviceTypeList: Array<{ key: string; value: string; gatewayProfileId: string; netmask: number }>;
    device: string;
}> = (props) => {
    const history = useHistory();
    const { t } = useLanguageLocale();
    const classes = deviceStyles();
    const dispatch = useDispatch();
    const { addToast } = useToasts();
    const authHelper = useAuthHelper();
    const currentAppRoute = useCurrentAppRoute();
    const meshDeviceState = useSelector(MeshDeviceSelectors.deviceRegistration);
    const excludedStatesData: any = useSelector(SiteSelectors.excludedStates);
    const selectedState: any = useSelector(SiteSelectors.selectedState);
    const [isExceptionState, setIsExceptionState] = useState(false);
    const [meshgatewayDevice, setMeshGatewayDevice] = useState<MeshDeviceRegistration>();
    const dstDates = getDaylightsavingDates(new Date().getFullYear());
    const [startDate] = useState<Date>(dstDates.start);
    const [endDate] = useState<Date>(dstDates.end);

    const onChangeValues = (value: any, type: string): void => {
        if (meshgatewayDevice) {
            const deviceObj: any = { ...meshgatewayDevice };
            deviceObj[`${type}`] = value;
            setMeshGatewayDevice(deviceObj);
        }
    };

    const onChangeName = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (isValidCharWithoutSpace(e.target.value)) onChangeValues(e.target.value, 'name');
    };

    const onDevicesCancel = (): void => {
        props.onCancel();
    };

    const handleClose = (): void => {
        dispatch(MeshDeviceActions.meshGatewayDeviceRegistrationUnmounted());
        if (currentAppRoute.type === 'AddDevice' && meshgatewayDevice)
            pushAppRoute(history, {
                type: 'SiteProfile',
                orgId: currentAppRoute.orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            });
    };

    const isDirty =
        (meshgatewayDevice && (meshgatewayDevice.name !== '' || meshgatewayDevice.timeToLive !== 0)) || false;

    const isDisableMesh = meshgatewayDevice && meshgatewayDevice.name.trim() && meshgatewayDevice.timeToLive !== 0;

    const isSubmitDisable = (): boolean | undefined => {
        if (!meshDeviceState.meshgatewayLoading && Boolean(isDisableMesh)) return true;
    };

    useEffect(() => {
        dispatch(MeshDeviceActions.meshGatewayDeviceMasterData(true));
        if (props.siteId !== '') {
            const gatewayObj = props.deviceTypeList.find((x) => x.key.toLowerCase() === MESH.toLowerCase());
            const meshDevice: MeshDeviceRegistration = {
                name: '',
                siteId: props.siteId,
                deviceProfileId: gatewayObj?.gatewayProfileId,

                timeToLive: 5,
            };
            setMeshGatewayDevice(meshDevice);
        }
    }, [props.siteId]); //eslint-disable-line react-hooks/exhaustive-deps

    const onSubmit = (): void => {
        let startDSTDate: string;
        let endDStDate: string;
        if (meshgatewayDevice && meshgatewayDevice.deviceProfileId) {
            // When the state is not in the exception list, then only the DST dates are considered
            if (!isExceptionState) {
                startDSTDate = startDate.toISOString();
                endDStDate = endDate.toISOString();
            } else {
                startDSTDate = new Date('1/1/22').toISOString();
                endDStDate = new Date('2/1/22').toISOString();
            }
            const meshGatewayDeviceData = {
                name: meshgatewayDevice.name,
                siteId: props.siteId,
                deviceProfileId: meshgatewayDevice.deviceProfileId,

                TimeToLive: meshgatewayDevice.timeToLive,
                dayLightSavingStartDate: startDSTDate,
                dayLightSavingEndDate: endDStDate,
            };
            dispatch(Thunks.MeshDevice.MeshDeviceRegistration(meshGatewayDeviceData, authHelper, addToast));
        }
    };

    // check selected state into the list of exludede state if so then said okay its inside state dont show DST 
    const isExceptionDSTState = (statesList: Array<{ state?: string }>): boolean => {
        let finalResult = false;
        // Check if the state is in the statesList
        finalResult = statesList.some((stateItem) => stateItem.state === selectedState);
        return finalResult;
    };

    useEffect(() => {
        const stateList = excludedStatesData.states;
        setIsExceptionState(isExceptionDSTState(stateList));
    }, []);


    function formatDateShowInTextBox(date: Date): string {
        return moment(date).format('MM/DD/YYYY');
    }
    return (
        <Box>
            {meshgatewayDevice && (
                <>
                    <Box className={classes.padding8}>
                        <TextField
                            inputProps={{ 'data-testid': 'device-name' }}
                            className={classes.fullWidth}
                            required
                            variant="filled"
                            value={meshgatewayDevice.name}
                            id="MeshName"
                            label="Mesh Name"
                            onChange={(e): void => onChangeName(e)}
                        />
                    </Box>

                    {!isExceptionState ? (
                        <Box>
                            <Box className={`${classes.padding8}`} display="flex" justifyContent="space-between">
                                <Box style={{ width: '50%', paddingLeft: 0 }} className={`${classes.padding8}`}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'device-name' }}
                                        className={classes.fullWidth}
                                        required
                                        variant="filled"
                                        value={formatDateShowInTextBox(startDate)}
                                        id="DaylightStart"
                                        label="Daylight Saving Start Date"
                                        disabled={true}
                                    />
                                </Box>
                                <Box style={{ width: '50%', paddingLeft: 0 }} className={`${classes.padding8}`}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'device-name' }}
                                        className={classes.fullWidth}
                                        required
                                        variant="filled"
                                        value={formatDateShowInTextBox(endDate)}
                                        id="DaylightEnd"
                                        label="Daylight Saving End Date"
                                        disabled={true}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    ) : <>
                        <EmptyState
                            title={'Daylight Saving Time'}
                            description={'It appears that daylight saving (DST) is not observed for selected location.'}
                            icon={
                                <div style={{ fontSize: 64 }}>
                                    <ReportIcon id={'info-outline'} fontSize={'inherit'} htmlColor={colors.grey[500]} />
                                </div>
                            }
                        />
                    </>}

                    <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '24px 8px' }}>
                        <Button
                            style={{ marginRight: 16 }}
                            variant="outlined"
                            color="primary"
                            data-testid="cancel-device"
                            onClick={(): void => onDevicesCancel()}
                        >
                            {t('ACTIONS.CANCEL')}
                        </Button>
                        <Button
                            variant="contained"
                            disabled={!isSubmitDisable()}
                            startIcon={
                                meshDeviceState.meshgatewayLoading ? (
                                    <CircularProgress size="1rem" style={{ color: 'white' }} />
                                ) : (
                                    <></>
                                )
                            }
                            color="primary"
                            data-testid="add-device-button"
                            onClick={onSubmit}
                        >
                            {t('ACTIONS.SUBMIT')}
                        </Button>
                    </Box>
                </>
            )}

            {meshDeviceState.meshgatewaySuccess && (
                <ConfirmationPopUp
                    title="Success!"
                    body={
                        <div style={{ wordWrap: 'break-word' }}>
                            <Typography variant="body2">
                                {meshgatewayDevice ? meshgatewayDevice.name : ''} created successfully.
                            </Typography>
                        </div>
                    }
                    okButtonText={'OK'}
                    show={meshDeviceState.meshgatewaySuccess}
                    handleOk={handleClose}
                    okButtonShow={true}
                    width="xs"
                ></ConfirmationPopUp>
            )}
            {!meshDeviceState.meshgatewaySuccess && <NavigationPromptModal isDirty={isDirty} />}
        </Box>
    );
};
